import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { surveyAxiosInstance } from "../../surveybuilder/CommonFunctions/CommonFunction";
import { surveyEndpoints as SURVEY_ENDPOINT } from "../../surveybuilder/SurveyEndpoints/SurveyEndpoints";
import { postData } from "../../../axios/apiHelper";
import { ENDPOINT as API_ENDPOINT } from "../../../axios/apiConfig";
import AddTopicsModal from "../../CommonComponent/AddTopicPopup";
import { toast } from "react-toastify";
import { loader } from "../../../loader";
// import LinkWithTooltip from "../../../onesource/ui/components/LinkWithTooltip";
import axios from "axios";
import { Editor } from "@tinymce/tinymce-react";
import { Dropdown } from "react-bootstrap";
import { LinkWithTooltip } from "../../Library/R&D/StaticData";
export default function CreateVwdEmail(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { userList, isInternal } = location.state || {};

  const [clinicalTopic, setclinicalTopic] = useState([]);
  const [functionTopic, setfunctionTopic] = useState([]);
  const [emailDescription, setEmailDescription] = useState(
    location.state?.emailState?.emailDescription ||
      location.state?.emailDescription ||
      "Invite Email",
  );
  const [emailSubject, setEmailSubject] = useState(
    location.state?.emailState?.emailSubject ||
      location.state?.emailSubject ||
      "Welcome to the VWD Journey Platform",
  );
  const [selectedClinicalTopic, setselectedClinicalTopic] = useState(
    location.state?.emailState?.selectedClinicalTopic ||
      location.state?.selectedClinicalTopic ||
      [],
  );
  const [selectedFunctionTopic, setselectedFunctionTopic] = useState(() => {
    const fromEmailState = location.state?.emailState?.selectedFunctionTopic;
    const fromParentState = location.state?.selectedFunctionTopic;
    
    if (fromEmailState && fromEmailState.length > 0) return fromEmailState;
    if (fromParentState && fromParentState.length > 0) return fromParentState;
    
    return ["Invite", "vWD Journey"];
  });
  const [showTopicsModal, setShowTopicsModal] = useState(false);
  const [errors, setErrors] = useState({});

  // Template/Editor State
  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState(
    location.state?.emailState?.selectedTemplateId || null
  );
  const [emailContent, setEmailContent] = useState(
    location.state?.emailState?.emailContent || ""
  );

  const editorRef = useRef(null);
  const templateIdRef = useRef(selectedTemplateId || "");
  const linkingPayload = useRef();
  const [newTemplateContent, setNewTemplateContent] = useState(
    location.state?.emailState?.emailContent || ""
  );
  const [templateName, setTemplateName] = useState(
    location.state?.emailState?.templateName || ""
  );
  const [showProgress, setShowProgress] = useState(false);
  const [percent, setPercent] = useState(0);
  const [progress, setProgress] = useState(0);

  const fetchTopics = async () => {
    try {
      const body = {
        user_id: localStorage.getItem("user_id"),
      };
      const response = await surveyAxiosInstance.post(
        SURVEY_ENDPOINT.LIBRARY_USER_DETAIL,
        body,
      );
      if (response?.data?.status === 200) {
        // Handle cases where data might be at response.data.data or response.data
        const rawData = response?.data?.data || response?.data;
        const tags = rawData?.tags || [];
        const functionalTags = rawData?.functional_tags || [];

        // Map tags to clinical topics (extract strings from .value)
        const clinicalList = tags.map((item) => (typeof item === "string" ? item : item.value)).filter(Boolean);
        const functionalList = functionalTags.map((item) => (typeof item === "string" ? item : item.value)).filter(Boolean);

        setclinicalTopic(clinicalList);
        setfunctionTopic(functionalList);
      }
    } catch (err) {
      console.error("Error fetching topics:", err);
    }
  };

  const fetchEmailTemplates = async () => {
    const body = {
      user_id: props?.type === "vwd" ? "FOkB/AUT2wGXRv ablqvbg==" : localStorage.getItem("user_id"),
      language: 10, // All/Default
      ibu: "",
      vwd_invitation: 1,
      invitation_type: isInternal ? "internal" : "external",
      content_included: "0",
    };
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_KEY}emailapi/get_template_list`, body);
      if (response?.data?.status_code === 200) {
        const templates = response.data.response.data || [];
        setTemplateList(templates);
        const existingTemplate = templates.find(t => String(t.id) === String(selectedTemplateId));
        if (templates.length > 0) {
          if (!selectedTemplateId || !newTemplateContent || !existingTemplate) {
            const template = templates[0];
            setSelectedTemplateId(template.id);
            templateIdRef.current = template.id;
            setTemplateName(template.template_name || template.subject);
            setNewTemplateContent(template.source_code);
            setEmailContent(template.source_code);
          }
        } else {
          // Fallback if no specific VWD template is found
          if (!newTemplateContent) {
            const fallbackContent = `
              <div style="font-family: Arial, sans-serif; padding: 20px;">
                <h1>Welcome to VWD Journey</h1>
                <p>Hello,</p>
                <p>We are excited to invite you to our platform. Please click below to get started.</p>
                <div style="text-align: center; margin: 30px 0;">
                  <a href="#" style="background-color: #5d34a4; color: white; padding: 12px 24px; text-decoration: none; border-radius: 5px;">Get Started</a>
                </div>
                <p>Best regards,<br/>The VWD Team</p>
              </div>`;
            setNewTemplateContent(fallbackContent);
            setTemplateName("VWD Invitation Fallback");
          }
        }
      }
    } catch (err) {
      console.error("Error fetching email templates:", err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      loader("show");
      if (isInternal !== undefined)
        await Promise.all([fetchTopics(), fetchEmailTemplates()]);
      else await fetchTopics();
      setTimeout(() => {
        loader("hide");
      }, 1500);
    };
    fetchData();
  }, [isInternal]);

  const addTracking = function (editor) {
    editor.on("OpenWindow", function (e) {
      let dialog = document.getElementsByClassName("tox-dialog")[0];
      if (dialog) {
        let header = dialog?.querySelector(".tox-dialog__header");
        const closeButton = header?.querySelector('[aria-label="Close"]');
        let text = header?.querySelector(".tox-dialog__title");
        let url = dialog?.querySelector(".tox-control-wrap");
        let newLink = url?.querySelector(".tox-textfield");
        let newButton = document.createElement("button");
        const baseLink =
          "https://webinar.docintel.app/lmn/api/track_multilinks?token=###updateid###&tracking_code=clicked_track_doc_";
        let payload = {};
        let apiLink = "";

        if (text?.innerText == "Insert/Edit Link") {
          let uploadIcon = document.querySelector(
            "body > div.tox.tox-silver-sink.tox-tinymce-aux > div > div.tox-dialog > div.tox-dialog__content-js > div > div > div > div:nth-child(1) > div > button > span",
          );
          if (uploadIcon) uploadIcon.style.display = "none";
          if (newLink?.value?.includes(baseLink)) {
            newButton.innerText = "Remove Tracking";
            apiLink = `https://onesource.informed.pro/api/delete-track-links`;
          } else {
            newButton.innerText = "Add Tracking";
            apiLink = `https://onesource.informed.pro/api/track-links`;
          }
          newButton.classList.add("tox-button");
          newButton.classList.add("tox-button--icon");
          newButton.classList.add("tox-button--naked");
          newButton.classList.add("track");

          newButton.onclick = function () {
            if (templateIdRef.current == "") {
              alert("Please select the template first before adding the link");
              return;
            }
            let firstToxControlWrap = document.querySelector(
              "body > div.tox.tox-silver-sink.tox-tinymce-aux > div > div.tox-dialog > div.tox-dialog__content-js > div > div > div > div:nth-child(1) > div > div >input",
            );

            if (newLink?.value?.includes(baseLink) && newButton.innerText == "Remove Tracking") {
              if (!window.confirm("Are you sure you want to remove the tracking?")) {
                return;
              }
              const urlParams = new URLSearchParams(newLink.value);
              const redirectUrl = urlParams.get("redirect_url");
              const trackingCode = urlParams.get("tracking_code");
              firstToxControlWrap.value = redirectUrl;
              payload = {
                template_id: templateIdRef.current,
                url_code: trackingCode,
              };
            }

            if (!newLink?.value?.includes(baseLink) && newButton.innerText == "Add Tracking") {
              if (!newLink?.value) {
                alert("Please enter a link");
                return;
              }
              if (!firstToxControlWrap.value) {
                alert("Please enter a link");
                return;
              }
              if (firstToxControlWrap.value.startsWith(baseLink)) {
                alert("Tracking already added");
                return;
              }
              let slugValue = prompt("Enter a slug value");

              const currentTimestamp = Date.now();
              payload = {
                slug_value: slugValue,
                template_id: templateIdRef.current,
                url_code: `clicked_track_doc_${currentTimestamp}`,
              };
              linkingPayload.current = payload;
              let link = `https://webinar.docintel.app/lmn/api/track_multilinks?token=###updateid###&tracking_code=clicked_track_doc_${currentTimestamp}&redirect_url=${firstToxControlWrap.value}`;
              firstToxControlWrap.value = link;
            }

            var saveButton = document.querySelector('.tox-button[title="Save"]');
            saveButton.addEventListener("click", function () {
              axios
                .post(apiLink, payload)
                .then((res) => {})
                .catch((err) => {
                  console.log(err);
                });
            });
            if (newLink?.value?.includes(baseLink)) {
              alert("Tracking added");
            } else {
              if (saveButton) saveButton.click();
              alert("Tracking removed");
            }
          };

          if (header) header.insertBefore(newButton, closeButton);
        } else if (text.innerText == "Insert/Edit Media") {
          const mediaLabel = document.querySelector(
            "body > div.tox.tox-silver-sink.tox-tinymce-aux > div.tox-dialog-wrap > div.tox-dialog > div.tox-dialog__content-js > div > div.tox-dialog__body-content > div > div:nth-child(1) > label",
          );
          if (mediaLabel) mediaLabel.innerText += " (Max size: 1GB)";
        }
      }
    });
  };

  const uploadImageToServer = async function (file) {
    try {
      const formData = new FormData();
      formData.append("image", file);

      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        let tox = document.querySelector(
          "body > div.tox.tox-silver-sink.tox-tinymce-aux > div.tox-dialog-wrap > div.tox-dialog",
        );
        let tox1 = document.querySelector(
          "body > div.tox.tox-silver-sink.tox-tinymce-aux > div.tox-dialog-wrap > div.tox-dialog-wrap__backdrop",
        );
        let aux = document.querySelector("body > div.tox.tox-silver-sink.tox-tinymce-aux > div > div");

        xhr.upload.addEventListener("progress", (event) => {
          setShowProgress(true);
          if (tox) tox.style.opacity = 0;
          if (tox1) tox1.style.opacity = 0;
          if (aux) aux.style.opacity = 0;
          if (event?.lengthComputable) {
            const percentComplete = (event?.loaded / event?.total) * 100;
            setProgress(parseInt(event?.loaded / event?.total));
            setPercent(parseInt(percentComplete));
          }
        });

        xhr.addEventListener("load", () => {
          if (xhr?.status === 200) {
            try {
              const uploadedData = JSON.parse(xhr?.responseText);
              const imageUrl = uploadedData?.imageUrl;
              resolve(imageUrl);
            } catch (parseError) {
              console.error("Failed to parse response JSON:", parseError);
              reject(null);
            } finally {
              setShowProgress(false);
              if (tox1) tox1.style.opacity = 1;
              if (tox) tox.style.opacity = 1;
              if (aux) aux.style.opacity = 1;
              setProgress(0);
              setPercent(0);
            }
          } else {
            console.error("Image upload failed");
            reject(null);
          }
        });

        xhr.addEventListener("error", (error) => {
          console.error("Image upload error:", error);
          reject(null);
        });

        xhr.open("POST", `${process.env.REACT_APP_API_KEY}api/upload-image`);
        xhr.send(formData);
      });
    } catch (error) {
      console.error("Image upload error:", error);
      return null;
    }
  };


  const updateTemplate = async () => {
    if (!selectedTemplateId || !editorRef.current) return;

    const body = {
      user_id: localStorage.getItem("user_id"),
      source_code: newTemplateContent,
      template_id: selectedTemplateId,
      name: templateName,
      status: 2,
      language: 2,
      content_included: 0,
      type: isInternal ? 3 : 4,
    };

    try {
      loader("show");
      const res = await axios.post(`${process.env.REACT_APP_API_KEY}emailapi/add_update_template`, body);
      if (res.data.status_code === 200) {
        toast.success("Template changes saved successfully");
      }
    } catch (err) {
      console.error("Error updating template:", err);
      toast.error("Failed to save template changes");
    } finally {
      loader("hide");
    }
  };

  const handleTemplateSelect = (template) => {
    setSelectedTemplateId(template.id);
    templateIdRef.current = template.id;
    setTemplateName(template.template_name || template.subject);
    setNewTemplateContent(template.source_code);
    setEmailContent(template.source_code);
    setErrors((prev) => ({ ...prev, emailTemplate: "" }));
  };

  const handleNextClick = async () => {
    const newErrors = {};
    if (!emailDescription.trim()) {
      newErrors.emailDescription = "Email Description is required";
    }
    if (!emailSubject.trim()) {
      newErrors.emailSubject = "Email Subject is required";
    }
    if (!selectedTemplateId) {
      newErrors.emailTemplate = "Template not loaded. Please wait or refresh.";
    }
    if (!newTemplateContent.trim()) {
      newErrors.emailContent = "Email content cannot be empty";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }


    navigate("/vwd/verify-email", {
      state: {
        userList,
        isInternal,
        emailState: {
          emailDescription,
          emailSubject,
          selectedClinicalTopic,
          selectedFunctionTopic,
          emailContent: newTemplateContent,
          selectedTemplateId,
          templateName,
        },
      },
    });
  };

  const getLibraryDataOnSave = () => {
    setShowTopicsModal(false);
  };

  const handleAddClinicalTopic = async (topicName) => {
    if (!topicName.trim()) {
      toast.warning("Please enter clinical topic");
      return;
    }
    if (clinicalTopic.includes(topicName.trim())) {
      toast.warning("Topic already exists");
      return;
    }

    try {
      const response = await postData(API_ENDPOINT.ADD_TAGS, {
        product: topicName.trim(),
        type: 2,
        category: 0,
        irt: 0,
      });

      if (response?.status === 200 || response?.status === 201 || response?.data?.status_code === 200) {
        toast.success("Clinical topic added successfully");
        setclinicalTopic((prev) => [...prev, topicName.trim()]);
        return true;
      } else {
        toast.error(response?.data?.message || "Failed to add topic");
        return false;
      }
    } catch (err) {
      console.error("Error adding clinical topic:", err);
      toast.error("An error occurred while adding topic");
      return false;
    }
  };

  const handleAddFunctionTopic = async (topicName) => {
    if (!topicName.trim()) {
      toast.warning("Please enter functional topic");
      return;
    }
    if (functionTopic.includes(topicName.trim())) {
      toast.warning("Topic already exists");
      return;
    }

    try {
      const response = await postData(API_ENDPOINT.ADD_TAGS, {
        product: topicName.trim(),
        type: 21,
        category: 0,
        irt: 0,
      });

      if (response?.status === 200 || response?.status === 201 || response?.data?.status_code === 200) {
        toast.success("Functional topic added successfully");
        setfunctionTopic((prev) => [...prev, topicName.trim()]);
        return true;
      } else {
        toast.error(response?.data?.message || "Failed to add topic");
        return false;
      }
    } catch (err) {
      console.error("Error adding functional topic:", err);
      toast.error("An error occurred while adding topic");
      return false;
    }
  };

  const removeClinicalTopic = (topic) => {
    setselectedClinicalTopic((prev) => prev.filter((t) => t !== topic));
  };

  const removeFunctionTopic = (topic) => {
    setselectedFunctionTopic((prev) => prev.filter((t) => t !== topic));
  };

  let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;

  const handleBackClick = useCallback(
    (e) => {
      e.preventDefault();
      navigate("/vwd/invite-user", {
        state: {
          userList,
          isInternal,
          emailState: {
            emailDescription,
            emailSubject,
            selectedClinicalTopic,
            selectedFunctionTopic,
            emailContent: newTemplateContent,
            selectedTemplateId,
          },
        },
      });
    },
    [
      navigate,
      userList,
      isInternal,
      emailDescription,
      emailSubject,
      selectedClinicalTopic,
      selectedFunctionTopic,
      newTemplateContent,
      selectedTemplateId,
    ],
  );

  return (
    <>
      <div className="col right-sidebar custom-change vwd-create-email">
        <div className="custom-container">
          <div className="row">
            <div className="page-top-nav sticky">
              <div className="row justify-content-end align-items-center">
                <div className="col-12 col-md-1">
                  <div className="header-btn-left">
                    <button
                      className="btn btn-primary btn-bordered back"
                      onClick={handleBackClick}
                    >
                      <Link>Back</Link>
                    </button>
                  </div>
                </div>
                <div className="col-12 col-md-9">
                  <ul className="tabnav-link">
                    <li className="">
                      <a href="">Add User</a>
                    </li>
                    <li className="active active-main">
                      <a href="">Create Your Email</a>
                    </li>
                    <li className="">
                      <a href="">Verify your Email</a>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-md-2">
                  <div className="header-btn">

                    <button
                      className="btn btn-primary btn-filled next"
                      onClick={handleNextClick}
                      disabled={!emailDescription?.trim() || !emailSubject?.trim()}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="top-header">
              <div className="custom-container">
                <div className="row">
                  <div className="page-title">
                    <h4>Email Details</h4>
                  </div>
                </div>
              </div>
            </div>

            <section className="select-mail-template">
              <div className="custom-container">
                <div className="row">
                  <div className="email-form padding-add">
                    <form>
                      <div className="form-inline d-flex justify-content-between align-items-center">
                        <div className="form-group col-12 col-md-7 d-flex align-items-center">
                          <label>
                            Email Description <span>*</span>
                            <LinkWithTooltip
                              tooltip="About this specific email, this description will aid in distinguishing it from others."
                              href="#"
                            >
                              <img
                                src={path_image + "info_circle_icon.svg"}
                                alt="refresh-btn"
                              />
                            </LinkWithTooltip>
                          </label>
                           <input
                            type="text"
                            className={`form-control ${errors.emailDescription ? "is-invalid" : ""}`}
                            value={emailDescription}
                            onChange={(e) => {
                              setEmailDescription(e.target.value);
                              setErrors((prev) => ({ ...prev, emailDescription: "" }));
                            }}
                            placeholder="Sample description"
                          />
                          {errors.emailDescription && (
                            <div className="invalid-feedback">
                              {errors.emailDescription}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="input-group d-flex w-100">
                        <div className="input-group-prepend">
                          <button
                            type="button"
                            className="btn btn-bordered btn-primary"
                            onClick={() => setShowTopicsModal(true)}
                          >
                            + Add Topics
                          </button>
                        </div>

                        <div className="tags_added">
                          <ul>
                            {selectedClinicalTopic.map((topic, index) => (
                              <li key={`clinical-${index}`} className="list1 clinical">
                                {topic}{" "}
                                <img
                                  src={path_image + "filter-close-blue.svg"}
                                  alt="Close-filter"
                                  onClick={() => removeClinicalTopic(topic)}
                                  style={{ cursor: "pointer" }}
                                />
                              </li>
                            ))}
                            {selectedFunctionTopic.map((topic, index) => (
                              <li key={`functional-${index}`} className="list1 functional">
                                {topic}{" "}
                                <img
                                  src={path_image + "filter-close.svg"}
                                  alt="Close-filter"
                                  onClick={() => removeFunctionTopic(topic)}
                                  style={{ cursor: "pointer" }}
                                />
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>

                      <div className="form-inline d-flex justify-content-between align-items-center">
                        <div className="form-group col-12 col-md-7 d-flex align-items-center">
                          <label htmlFor="emailSubject">
                            Email Subject <span>*</span>
                          </label>
                          <input
                            type="text"
                            id="emailSubject"
                            className={`form-control ${errors.emailSubject ? "is-invalid" : ""}`}
                            value={emailSubject}
                            onChange={(e) => {
                              setEmailSubject(e.target.value);
                              setErrors((prev) => ({ ...prev, emailSubject: "" }));
                            }}
                            placeholder="Sample subject"
                          />
                          {errors.emailSubject && (
                            <div className="invalid-feedback">
                              {errors.emailSubject}
                            </div>
                          )}
                        </div>

                        <div className="form-action d-flex justify-content-end w-100">
                          <button
                            className="btn btn-primary btn-filled next"
                           onClick={(e) => {
                              e.preventDefault();
                              updateTemplate();
                            }}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              <div className="card shadow-sm p-4 mt-4">
              

                {/* TinyMCE Editor */}
                <div className="row">
                  <div style={{ minHeight: "400px", width: "100%" }}>
                     <Editor
                                              apiKey="gpl"
                                              tinymceScriptSrc={window.location.origin+ '/tinymce/tinymce.min.js'}
                                              onInit={(evt, editor) => (editorRef.current = editor)}
                                              value={newTemplateContent}
                                              link_default_protocol={"https"}
                                              link_assume_external_targets={"https"}
                                              relative_urls={true}
                                              init={{
                                                height: "100vh",
                                                highlight_on_focus: false,
                                                menubar:
                                                  "file edit view insert format tools table help",
                                                plugins:
                                                  "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons",
                                                toolbar:
                                                  "undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media link anchor codesample | ltr rtl",
                                                content_style:
                                                  "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                file_picker_types: "file image media",
                    
                                                file_picker_callback: function (callback, value, meta) {
                                                  const input = document.createElement("input");
                    
                                                  if (meta.filetype === "media") {
                                                    input.setAttribute("type", "file");
                                                    input.setAttribute("accept", "video/*");
                    
                                                    input.onchange = async () => {
                                                      const file = input.files[0];
                                                      if (file) {
                                                        let uploadedImageUrl;
                    
                                                        try {
                                                          if (meta && meta.width && meta.height) {
                                                            uploadedImageUrl =
                                                              await uploadImageToServer(
                                                                file,
                                                                meta.width,
                                                                meta.height
                                                              );
                                                          } else {
                                                            uploadedImageUrl =
                                                              await uploadImageToServer(file);
                                                          }
                    
                                                          if (uploadedImageUrl) {
                                                            callback(uploadedImageUrl, {
                                                              width: 500,
                                                              height: 500,
                                                            });
                                                          } else {
                                                            console.error("Failed to upload image");
                                                          }
                                                        } catch (error) {
                                                          console.error(
                                                            "Error uploading image:",
                                                            error
                                                          );
                                                        } finally {
                                                        }
                                                      }
                                                    };
                                                  } else {
                                                    input.setAttribute("type", "file");
                                                    input.setAttribute("accept", "image/*");
                    
                                                    // Create a loading indicator element (e.g., a spinner)
                                                    const loadingIndicator =
                                                      document.createElement("div");
                                                    loadingIndicator.className = "loading-indicator";
                                                    loadingIndicator.textContent = "Uploading..."; // You can use a spinner icon or any text you prefer
                    
                                                    input.onchange = async () => {
                                                      document.body.appendChild(loadingIndicator); // Show loading indicator
                    
                                                      const file = input.files[0];
                                                      if (file) {
                                                        let uploadedImageUrl;
                    
                                                        try {
                                                          if (meta && meta.width && meta.height) {
                                                            uploadedImageUrl =
                                                              await uploadImageToServer(
                                                                file,
                                                                meta.width,
                                                                meta.height
                                                              );
                                                          } else {
                                                            uploadedImageUrl =
                                                              await uploadImageToServer(file);
                                                          }
                    
                                                          if (uploadedImageUrl) {
                                                            callback(uploadedImageUrl, {
                                                              width: 500,
                                                              height: 500,
                                                            });
                                                            loader("hide");
                                                          } else {
                                                            console.error("Failed to upload image");
                                                          }
                                                        } catch (error) {
                                                          console.error(
                                                            "Error uploading image:",
                                                            error
                                                          );
                                                        } finally {
                                                          document.body.removeChild(loadingIndicator); // Hide loading indicator
                                                        }
                                                      }
                                                    };
                                                  }
                                                  input.click();
                                                },
                                                init_instance_callback: (editor) => addTracking(editor),
                                              }}
                                              onEditorChange={(content) => {
                                                setNewTemplateContent(content);
                                              }}
                                            />
                  </div>
                </div>
              </div>
                </div>
            </section>
          </div>
        </div>
      </div>
      <AddTopicsModal
        shown={showTopicsModal}
        clinicalTopic={clinicalTopic}
        functionTopic={functionTopic}
        setclinicalTopic={setclinicalTopic}
        setfunctionTopic={setfunctionTopic}
        selectedClinicalTopic={selectedClinicalTopic}
        selectedFunctionTopic={selectedFunctionTopic}
        setselectedClinicalTopic={setselectedClinicalTopic}
        setselectedFunctionTopic={setselectedFunctionTopic}
        handleAddClinicalTopic={handleAddClinicalTopic}
        handleAddFunctionTopic={handleAddFunctionTopic}
        getLibraryDataOnSave={getLibraryDataOnSave}
        onClose={() => setShowTopicsModal(false)}
      />
    </>
  );
}
